import { toError } from '@fruitful/fruitils';
import { useEffect, useState } from 'react';

interface MaintenanceStatus {
    maintenanceMode: boolean;
    message?: string;
}

export function useGetMaintenanceStatus() {
    const url =
        'https://d1pwidzl9kib4u.cloudfront.net/product/maintenanceMode.json';
    const [maintenanceInfo, setMaintenanceInfo] =
        useState<MaintenanceStatus | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        let cancelled = false;

        async function fetchStatus() {
            try {
                setLoading(true);
                const res = await fetch(url, { cache: 'no-store' }); // skip caching so changes are immediate
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = (await res.json()) as MaintenanceStatus;
                if (!cancelled) setMaintenanceInfo(data);
            } catch (err) {
                if (!cancelled) setError(toError(err));
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        void fetchStatus();

        return () => {
            cancelled = true;
        };
    }, [url]);

    return { maintenanceInfo, loading, error };
}
